export default __webpack_public_path__ + "static/media/department-store.inline.6b25a53b.svg";